import { combineReducers } from 'redux'

import { clientDataReducer } from './clientData'
import { configurationReducer } from './configuration'
import { loginReducer } from './login'
import { sendToReducer } from './sendTo'

const rootReducer = combineReducers({
  clientData: clientDataReducer,
  configuration: configurationReducer,
  login: loginReducer,
  sendTo: sendToReducer,
})

export default rootReducer
